import { externalProgramMappingsApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE = createNamedActions('externalProgramMappings', {
  GET_EXTERNAL_PROGRAM_MAPPINGS: 'GET_EXTERNAL_PROGRAM_MAPPINGS',
  GET_PAGED_PROGRAM_MAPPINGS: 'GET_PAGED_PROGRAM_MAPPINGS',
  GET_GROUPED_PROGRAM_MAPPINGS: 'GET_GROUPED_PROGRAM_MAPPINGS',
  CREATE_EXTERNAL_PROGRAM_MAPPING: 'CREATE_EXTERNAL_PROGRAM_MAPPING',
  UPDATE_EXTERNAL_PROGRAM_MAPPING: 'UPDATE_EXTERNAL_PROGRAM_MAPPING',
  DELETE_EXTERNAL_PROGRAM_MAPPING: 'DELETE_EXTERNAL_PROGRAM_MAPPING',
  BATCH_UPDATE_PROGRAM_MAPPINGS: 'BATCH_UPDATE_PROGRAM_MAPPINGS',
  GET_OB_PRODUCTS: 'GET_OB_PRODUCTS',
  GET_GROUPED_OB_PRODUCTS: 'GET_GROUPED_OB_PRODUCTS',
  REFRESH_OB_PRODUCTS: 'REFRESH_OB_PRODUCTS',
});

const externalProgramMappingSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const getExternalProgramMappingsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await externalProgramMappingsApi.getMappings(params);

  return dispatch({
    type: EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.GET_EXTERNAL_PROGRAM_MAPPINGS,
    payload: normalize(data, [externalProgramMappingSchema]).entities.data || {},
  });
});

export const getPagedProgramMappingsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await externalProgramMappingsApi.getPagedMappings(params);
  const items = Array.isArray(data) ? data : data?.items || [];
  const totalCount = Array.isArray(data) ? data.length : data?.totalCount || 0;

  return dispatch({
    type: EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.GET_PAGED_PROGRAM_MAPPINGS,
    payload: { items, totalCount },
  });
});

export const getGroupedProgramMappingsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await externalProgramMappingsApi.getGroupedMappings(params);
  const items = Array.isArray(data) ? data : data?.items || [];
  const totalCount = Array.isArray(data) ? data.length : data?.totalCount || 0;

  return dispatch({
    type: EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.GET_GROUPED_PROGRAM_MAPPINGS,
    payload: { items, totalCount },
  });
});

export const createExternalProgramMappingAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await externalProgramMappingsApi.createMapping(params);

    return dispatch({
      type: EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.CREATE_EXTERNAL_PROGRAM_MAPPING,
      payload: data,
    });
  },
);

export const updateExternalProgramMappingAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await externalProgramMappingsApi.updateMapping(params);

    return dispatch({
      type: EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.UPDATE_EXTERNAL_PROGRAM_MAPPING,
      payload: data,
    });
  },
);

export const deleteExternalProgramMappingAction = catchAsyncActionError(
  params => async dispatch => {
    await externalProgramMappingsApi.deleteMapping(params);

    return dispatch({
      type: EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.DELETE_EXTERNAL_PROGRAM_MAPPING,
      meta: { ...params },
    });
  },
);

export const getObProductsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await externalProgramMappingsApi.getObProducts(params);

  return dispatch({
    type: EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.GET_OB_PRODUCTS,
    payload: data,
  });
});

export const getGroupedObProductsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await externalProgramMappingsApi.getGroupedObProducts(params);

  return dispatch({
    type: EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.GET_GROUPED_OB_PRODUCTS,
    payload: data,
  });
});

export const refreshObProductsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await externalProgramMappingsApi.refreshObProducts(params);

  return dispatch({
    type: EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.REFRESH_OB_PRODUCTS,
    payload: data,
  });
});

export const batchUpdateProgramMappingsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await externalProgramMappingsApi.batchUpdate(params);

  return dispatch({
    type: EXTERNAL_PROGRAM_MAPPINGS_ACTION_TYPE.BATCH_UPDATE_PROGRAM_MAPPINGS,
    payload: data,
  });
});
